import React, { useState, useEffect } from 'react';
import '../styles/ImageResizer.css';

const ImageResizer: React.FC = () => {
  const [image, setImage] = useState<File | null>(null);
  const [width, setWidth] = useState<number>(100);
  const [height, setHeight] = useState<number>(100);
  const [resizedImage, setResizedImage] = useState<string | null>(null);
  
  // Initialize AdSense
  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  const handleResize = () => {
    if (!image) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target?.result as string;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0, width, height);
        setResizedImage(canvas.toDataURL());
      };
    };
    reader.readAsDataURL(image);
  };

  return (
    <div className="image-resizer">
      <h2>Redimensionador de Imagem</h2>
      <input type="file" accept="image/*" onChange={handleImageChange} />
      <div className="mt-2">
        <label>Largura: </label>
        <input type="number" value={width} onChange={(e) => setWidth(Number(e.target.value))} />
        <label>Altura: </label>
        <input type="number" value={height} onChange={(e) => setHeight(Number(e.target.value))} />
      </div>
      <button onClick={handleResize} className="mt-2 p-2 bg-blue-500 text-white">Redimensionar</button>
      {resizedImage && (
        <div>
          <img src={resizedImage} alt="Imagem Redimensionada" className="mt-4" />
          <a href={resizedImage} download="imagem-redimensionada.png" className="mt-2 p-2 bg-green-500 text-white inline-block">Baixar Imagem</a>
        </div>
      )}
      {/* Google AdSense */}
      <div className="ad-container">
        <ins className="adsbygoogle"
             style={{ display: 'block' }}
             data-ad-client="ca-pub-1989683361613000"
             data-ad-slot="1234567890"
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>
      </div>
    </div>
  );
};

export default ImageResizer; 